import { c as _c } from "react/compiler-runtime";
import Section from "@components/Section";
import { getSerifClass } from "@components/utilities";
import { ComponentSectionsCtaWithImageV3 } from "@lib/generated/graphql";
import { FC } from "react";
import SectionImage from "../../../../components/SectionBlocks/SectionImage";
import SectionText from "../../../../components/SectionBlocks/SectionText";
import TwoColumnLayout from "../../../../components/SectionBlocks/TwoColumnLayout";
export interface CtaWithImageV3Props {
  data: ComponentSectionsCtaWithImageV3;
  index: number;
}
const CtaWithImageV3: FC<CtaWithImageV3Props> = t0 => {
  const $ = _c(26);
  const {
    data,
    index
  } = t0;
  let t1;
  if ($[0] !== data.background) {
    t1 = getSerifClass(data.background);
    $[0] = data.background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const serifClass = t1;
  let t2;
  if ($[2] !== data.image || $[3] !== index) {
    t2 = <SectionImage index={index} data={data.image} />;
    $[2] = data.image;
    $[3] = index;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== data.text || $[6] !== index || $[7] !== serifClass || $[8] !== t2) {
    t3 = <SectionText index={index} serifClass={serifClass} data={data.text} mobileSlot={t2} />;
    $[5] = data.text;
    $[6] = index;
    $[7] = serifClass;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== data.layout || $[11] !== t3) {
    t4 = <TwoColumnLayout.FirstColumn data={data.layout} className="m:py-3xl">{t3}</TwoColumnLayout.FirstColumn>;
    $[10] = data.layout;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== data.image || $[14] !== index) {
    t5 = <SectionImage data={data.image} index={index} />;
    $[13] = data.image;
    $[14] = index;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== data.layout || $[17] !== t5) {
    t6 = <TwoColumnLayout.SecondColumn data={data.layout} className="hidden m:flex">{t5}</TwoColumnLayout.SecondColumn>;
    $[16] = data.layout;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== data.layout || $[20] !== t4 || $[21] !== t6) {
    t7 = <TwoColumnLayout data={data.layout}>{t4}{t6}</TwoColumnLayout>;
    $[19] = data.layout;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== data || $[24] !== t7) {
    t8 = <Section section={data} className="my-2s m:my-3s">{t7}</Section>;
    $[23] = data;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
export default CtaWithImageV3;